import { Select } from "@mantine/core";
import type { MRT_ColumnDef } from "mantine-react-table-open";
import type { InvoiceState } from "../../../utils/backend-types";
import { INVOICE_STATE_CHOICES } from "../../../utils/constants";
import { type Doc } from "../../DeliveryOverview/DeliveryOverview.types";

function getStateColumn(
  onChangeStatus: (id: string, status: InvoiceState) => void = () => {}
): MRT_ColumnDef<Doc> {
  return {
    header: "Status",
    accessorKey: "state",
    filterVariant: "multi-select",
    size: 160,
    mantineFilterMultiSelectProps: {
      data: INVOICE_STATE_CHOICES
    },
    filterFn: (row, _columnId, filterValue) => {
      if (filterValue.length === 0) {
        return true;
      }

      return filterValue.includes(row.original.state);
    },
    Cell: ({ cell, row }) =>
      row.original.documentType === "draft" ? (
        ""
      ) : (
        <Select
          data={INVOICE_STATE_CHOICES}
          size="xs"
          value={cell.getValue<Doc["state"]>()}
          onChange={(value) => {
            if (value) {
              onChangeStatus(row.original.id, value as InvoiceState);
            }
          }}
        />
      )
  };
}

export { getStateColumn };
